import React from 'react';
import { StickyAlertBar, StickyBottomBar } from '../components/sections/StickyBars';
import { HeroSection } from '../components/sections/HeroSection';
import { SalesLetterSection } from '../components/sections/SalesLetterSection';
import { FeaturesSection } from '../components/sections/FeaturesSection';
import { BonusSection } from '../components/sections/BonusSection';
import { PricingSection } from '../components/sections/PricingSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { ValueStackSection } from '../components/sections/ValueStackSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
export function LandingPage() {
  return <div className="min-h-screen bg-cream font-sans text-ink selection:bg-pain selection:text-white" data-id="element-262">
      <StickyAlertBar data-id="element-263" />

      <main className="overflow-x-hidden" data-id="element-264">
        <HeroSection data-id="element-265" />
        <SalesLetterSection data-id="element-266" />
        <FeaturesSection data-id="element-267" />
        <BonusSection data-id="element-268" />
        <PricingSection data-id="element-269" />
        <TestimonialsSection data-id="element-270" />
        <ValueStackSection data-id="element-271" />
        <GuaranteeSection data-id="element-272" />
        <FAQSection data-id="element-273" />
        <FinalCTASection data-id="element-274" />
      </main>

      <StickyBottomBar data-id="element-275" />
    </div>;
}